export default __webpack_public_path__ + "static/media/glass.9c04a4a6.svg";